<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
</div>
<div class="navi-hover card-body" style="max-height: 650px; padding: 0">
  <div class="form-section form-section-first">
    <div class="mat-table-wrapper" style="padding: 25px; background-color: white">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="attemptsDataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="asc"
        matSortDisableClear
        style="max-height: 400px; overflow-y: auto"
      >
        <ng-container matColumnDef="attempt">
          <mat-header-cell *matHeaderCellDef>Attempt</mat-header-cell>
          <mat-cell *matCellDef="let followup; let i = index"> {{ i + 1 }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="contact">
          <mat-header-cell *matHeaderCellDef>Contact</mat-header-cell>
          <mat-cell *matCellDef="let followup"> {{ getContact(followup.contact_id) }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="start">
          <mat-header-cell *matHeaderCellDef>Start</mat-header-cell>
          <mat-cell *matCellDef="let followup; let i = index"> {{ getStarted(i) }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="end">
          <mat-header-cell *matHeaderCellDef>End</mat-header-cell>
          <mat-cell *matCellDef="let followup; let i = index"> {{ getEnded(i) }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="reason">
          <mat-header-cell *matHeaderCellDef>Reason</mat-header-cell>
          <mat-cell *matCellDef="let followup"> {{ followup.reason_name }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef>Comment</mat-header-cell>
          <mat-cell *matCellDef="let followup"> {{ followup.attempt_comment }} </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedAttemptColumns"
          class="sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedAttemptColumns"></mat-row>
      </mat-table>
      <div class="mat-table__message" *ngIf="!attemptsDataSource">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
    </div>
  </div>
</div>

<div class="card-footer">
  <div class="d-flex justify-content-between">
    <div class="mr-2"></div>
    <div>
      <button (click)="close()" type="button" mat-raised-button cdkFocusInitial matTooltip="Cancel">
        <span>Close</span></button
      >&nbsp;
    </div>
  </div>
</div>
